export const PROFILE_PHOTO_SIZE = 104
export const MAX_CONTENT_WIDTH = 1280
